/* FJC: return-to-spot on collection pages.
   Pairs with snippets/fjc-back-button.liquid (PDP "< BACK" button).

   On a collection page, remember which product the customer clicked.
   When they come back via back-navigation and the page is NOT served from
   bfcache (fresh load, Globo re-renders the grid async), poll for that
   product's card and scroll it into view — the reliable "same place",
   independent of grid height changes. Aborts if the user scrolls first. */
(function () {
  var KEY = 'fjcBackSpot';
  var MAX_AGE_MS = 10 * 60 * 1000;

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([a-zA-Z0-9-]+)/);
      if (!m) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ p: location.pathname, h: m[1], t: Date.now() }));
      } catch (err) {}
    },
    true
  );

  function findCard(handle) {
    var links = document.querySelectorAll('a[href*="/products/' + handle + '"]');
    for (var i = 0; i < links.length; i++) {
      try {
        var path = new URL(links[i].href, location.origin).pathname;
        var h = path.split('/products/')[1];
        if (h && h.split('/')[0].split('?')[0] === handle) return links[i];
      } catch (err) {}
    }
    return null;
  }

  function restore() {
    var data;
    try {
      data = JSON.parse(sessionStorage.getItem(KEY));
    } catch (err) {
      return;
    }
    if (!data || data.p !== location.pathname || Date.now() - data.t > MAX_AGE_MS) return;

    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type !== 'back_forward') return;

    var cancelled = false;
    var onUser = function () {
      cancelled = true;
    };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, onUser, { passive: true, once: true });
    });

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (cancelled || tries > 25) {
        clearInterval(timer);
        return;
      }
      var card = findCard(data.h);
      if (card) {
        clearInterval(timer);
        try {
          sessionStorage.removeItem(KEY);
        } catch (err) {}
        card.scrollIntoView({ block: 'center' });
      }
    }, 200);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      /* bfcache hit: browser restored scroll + loaded pages perfectly */
      try {
        sessionStorage.removeItem(KEY);
      } catch (err) {}
      return;
    }
    restore();
  });
})();
